import React from "react";
import PropTypes from "prop-types";
import { Store } from "../../../flux";
import Notifications from "./NavbarNav/Notifications";
import UserActions from "./NavbarNav/UserActions";
import { Link, useLocation } from "react-router-dom";
import NavbarSearch from "./NavbarSearch";

const DesktopNav = () => {
  const location = useLocation();
  const isCheckoutFlow =
    location.pathname.includes("/register") ||
    location.pathname.includes("/login") ||
    location.pathname.includes("NFT") ||
    location.pathname.includes("nft");

  const isActive = (itemPath) => {
    const currentPath = location.pathname;

    if (currentPath === itemPath) return true;
    if (itemPath === "/alerts" && currentPath.startsWith("/alerts/"))
      return true;
    if (itemPath === "/analysts" && currentPath.startsWith("/analyst/"))
      return true;
    if (
      itemPath === "/blogs/premium/" &&
      currentPath.startsWith("/blogs/premium/")
    )
      return true;
    if (
      itemPath === "/blogs/public" &&
      currentPath.startsWith("/blogs/public/")
    )
      return true;

    return false;
  };

  const navItems = Store.getSidebarItems() || [];

  return (
    <div
      className={`mainContainer${isCheckoutFlow ? " mainContainer--checkout" : ""}`}
    >
      <div className="mainContainer__leading">
        <Link to="/" className="mainContainer__brand" aria-label="Bitcoin Live home">
          <img
            id="main-logo"
            className="d-inline-block align-top mr-1 mainContainer__logo"
            src={require("../../../images/bitcoin-live/logo.png")}
            alt="Bitcoin Live"
          />
          <span className="d-none d-md-inline ml-1 mainContainer__wordmark">
            <span className="mainContainer__wordmark-bitcoin">BITCOIN</span>{" "}
            <span className="mainContainer__wordmark-live">LIVE</span>
          </span>
        </Link>
        <div className="mainContainer__search">
          <NavbarSearch />
        </div>
      </div>

      <nav className="mainContainer__nav navDiv" aria-label="Main navigation">
        {navItems.map((item) => (
          <Link to={item.to} key={item.to} className="navDiv__link">
            <span
              className={`navLabel ${isActive(item.to) ? "navLabel-active" : ""}`}
            >
              {item.title}
            </span>
          </Link>
        ))}
      </nav>

      <div className="mainContainer__actions">
        <Notifications />
        <UserActions />
      </div>
    </div>
  );
};

DesktopNav.propTypes = {
  layout: PropTypes.string,
  stickyTop: PropTypes.bool,
};

export default DesktopNav;
